import { IconProps } from '@/types/icon';

export function IconeCasa({ size, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="casa"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M8.00001 4.12683L11.3333 7.12683V12.3335H10V8.3335H6.00001V12.3335H4.66668V7.12683L8.00001 4.12683ZM8.00001 2.3335L1.33334 8.3335H3.33334V13.6668H7.33334V9.66683H8.66668V13.6668H12.6667V8.3335H14.6667L8.00001 2.3335Z"
        fill="currentColor"
      />
    </svg>
  );
}
